export default __webpack_public_path__ + "static/media/mastercard_logo.faca5df5.png";